import horizontalBar from "../graph/horizontalBar";
import utilParties from "../modules/utilParties";

function sum(a, b) {
  return a + b;
}

function getDefinitiveParties(validParties) {
  const selectedParties = validParties.slice(0, 6);

  const others = validParties.slice(6);
  if (others.length) {
    const sumPct = others
      .map((party) => parseFloat(party.votesPct))
      .reduce(sum);
    // const sumSeats = others
    //   .map((party) => parseInt(party.seats, 10))
    //   .filter((s) => !Number.isNaN(Number(s)))
    //   .reduce(sum);
    const sumVotes = others
      .map((party) => parseInt(party.votes, 10))
      .filter((v) => !Number.isNaN(Number(v)))
      .reduce(sum);
    const sumPctPrev =
      others[0].prevVotesPct >= 0
        ? others.map((party) => parseFloat(party.prevVotesPct)).reduce(sum)
        : null;
    // const sumSeatsPrev =
    //   others[0].prevSeats >= 0
    //     ? others
    //       .map((party) => parseFloat(party.prevSeats))
    //       .filter((s) => !Number.isNaN(Number(s)))
    //       .reduce(sum)
    //     : null;

    selectedParties.push({
      votesPct: Math.round(sumPct * 100) / 100,
      // seats: 0,
      votes: sumVotes.toLocaleString('de'),
      partyCode: "otros",
      partyAgg: window.ac_labels.percentage_of_votes.other,
      partyName: window.ac_labels.percentage_of_votes.other,
      prevVotesPct: sumPctPrev,
      increase: utilParties.hasIncrease(sumPctPrev, sumPct),
    });
  }

  selectedParties.sort(
    (a, b) => parseFloat(b.votesPct) - parseFloat(a.votesPct)
  );

  return selectedParties;
}

function compareValues(key, order = "asc") {
  return function innerSort(a, b) {
    if (
      !Object.prototype.hasOwnProperty.call(a, key) ||
      !Object.prototype.hasOwnProperty.call(b, key)
    ) {
      return 0;
    }

    const varA = typeof a[key] === "string" ? a[key].toUpperCase() : a[key];
    const varB = typeof b[key] === "string" ? b[key].toUpperCase() : b[key];

    let comparison = 0;
    if (varA > varB) {
      comparison = 1;
    } else if (varA < varB) {
      comparison = -1;
    }
    return order === "desc" ? comparison * -1 : comparison;
  };
}

function drawCurrent() {
  window.dataManager.getParties().then((parties) => {
    if (parties) {
      const validParties = parties.filter(
        (party) => parseFloat(party.votes) !== 0
      );
      horizontalBar.init(
        "ac-percentageOfVotes",
        getDefinitiveParties(validParties)
      );
    }
  });
}

function drawPrevious() {
  window.dataManager.getHistoricParties().then((parties) => {
    if (parties) {
      const validParties = parties.filter(
        (party) => parseFloat(party.votesPct) !== 0
      );
      horizontalBar.init(
        "ac-percentageOfVotes",
        getDefinitiveParties(validParties)
      );
    }
  });
}

function drawMixed() {
  window.dataManager.getParties().then((parties) => {
    if (parties) {
      const validParties = parties.filter(
        (party) => parseFloat(party.votes) !== 0
      );

      window.dataManager.getHistoricParties().then((partiesPrev) => {
        if (partiesPrev) {
          const partiesToDraw = [];
          const validPartiesPrev = partiesPrev.filter(
            (party) => parseFloat(party.votesPct) !== 0
          );
          const validPartiesAllYears = [...validParties, ...validPartiesPrev];
          validPartiesAllYears.forEach((party, index) => {
            let partyToDraw = {};
            if (index >= validParties.length) {
              if (
                !validParties.find(
                  (partyFind) => partyFind.partyCode === party.partyCode
                )
              ) {
                partyToDraw = {
                  partyAgg: party.partyAgg,
                  partyCode: party.partyCode,
                  partyId: party.partyId,
                  partyName: party.partyName,
                  votesPct: 0,
                  seats: 0,
                  votes: 0,
                  prevSeats: party.seats,
                  prevVotesPct: party.votesPct,
                };
                partiesToDraw.push(partyToDraw);
              }
            } else {
              let votesPrevPct = [];

              // Fix Por Andalucia elecciones 2022 -- REVISAR
              if (party.partyCode === "por-a") {
                votesPrevPct = validPartiesPrev.filter(
                  (partyPrev) => partyPrev.partyCode === "adelante-andalucia"
                );
              } else {
                votesPrevPct = validPartiesPrev.filter(
                  (partyPrev) => partyPrev.partyCode === party.partyCode
                );
              }

              partyToDraw = {
                partyAgg: party.partyAgg,
                partyCode: party.partyCode,
                partyId: party.partyId,
                partyName: party.partyName,
                votesPct: party.votesPct,
                seats: party.seats > 0 ? party.seats.toLocaleString('de') : 0,
                votes: party.votes > 0 ? party.votes.toLocaleString('de') : 0,
                prevVotesPct:
                  votesPrevPct.length > 0 ? votesPrevPct[0].votesPct : 0,
                prevSeats: votesPrevPct.length > 0 ? votesPrevPct[0].seats : 0,
                increase: utilParties.hasIncrease(
                  votesPrevPct.length > 0 ? votesPrevPct[0].votesPct : 0,
                  party.votesPct
                ),
              };
              partiesToDraw.push(partyToDraw);
            }
          });
          partiesToDraw.sort(compareValues("votesPct", "desc"));
          horizontalBar.init(
            "ac-percentageOfVotes",
            getDefinitiveParties(partiesToDraw)
          );
        }
      });
    }
  });
}

function changeTab(event) {
  switch (event.currentTarget.innerText) {
    case window.ac_labels.percentage_of_votes.current:
      drawCurrent();
      break;

    case window.ac_labels.percentage_of_votes.previous:
      drawPrevious();
      break;

    default:
      throw Error("There is not data for the year selected");
  }
}

function init() {
  const module = document.querySelector(
    '[data-controller*="ac-percentage-of-votes"]'
  );
  if (module) {
    if (module.dataset.type === "percentage-of-votes") {
      drawMixed();
    } else {
      drawCurrent();
    }

    document
      .querySelectorAll('[data-controller*="ac-percentage-of-votes"] .ac-tab')
      .forEach((button) => {
        button.addEventListener("click", changeTab);
      });
  }
}

export default init;
